module.exports = __webpack_public_path__ + "img/ears-06.9a14dc95.svg";